import type { AdminAccess, AppNotification, Department, Division, EmployeeStatus, OfficeLocation } from '../types/hr';

export const departmentNames: Department[] = ['Operations', 'Underwriting', 'Processing', 'Closing', 'Sales', 'Marketing', 'IT', 'Finance', 'HR'];
export const divisionNames: Division[] = ['Retail Lending', 'Wholesale', 'Corporate'];
export const locationNames: OfficeLocation[] = ['Main Office', 'Remote', 'Branch – East'];
export const statusNames: EmployeeStatus[] = ['Active', 'On Leave', 'Onboarding', 'Terminated'];

export const departmentLeads: Record<Department, string> = {
  Operations: 'Priya Nandakumar',
  Underwriting: 'Elena Ruiz',
  Processing: 'Dev Patel-Owens',
  Closing: 'Casey Morgan',
  Sales: 'Avery Lindqvist',
  Marketing: 'Taylor Brooks',
  IT: 'Riley Chen',
  Finance: 'Noah Fitzgerald',
  HR: 'Jordan Avery',
};

export const divisionDescriptions: Record<Division, string> = {
  'Retail Lending': 'Direct-to-consumer purchase & refinance',
  Wholesale: 'Broker partner channel',
  Corporate: 'Shared services & leadership',
};

export const locationAddresses: Record<OfficeLocation, string> = {
  'Main Office': '100 Example Ave, Sampletown, NY 11000',
  'Branch – East': '250 Demo Blvd, Sampletown, NY 11001',
  Remote: 'Distributed — various states',
};

export const adminAccess: AdminAccess[] = [
  { employeeId: 'e1', role: 'HR Admin', revealSsn: true, revealDob: true },
  { employeeId: 'e18', role: 'Payroll', revealSsn: true, revealDob: true },
  { employeeId: 'e2', role: 'Executive', revealSsn: false, revealDob: true },
  { employeeId: 'e7', role: 'System Admin (IT)', revealSsn: false, revealDob: false },
];

export const notifications: AppNotification[] = [
  { id: 'n1', title: 'New PTO request', body: 'Sam Okafor requested 1 day on Dec 24 (New Hire PTO).', time: '12m ago', unread: true, route: { page: 'timeoff', tab: 'requests' } },
  { id: 'n2', title: 'Work anniversary today', body: 'Taylor Brooks celebrates 7 years with Madison Mortgage.', time: '2h ago', unread: true, route: { page: 'profile', employeeId: 'e9' } },
  { id: 'n3', title: 'Onboarding incomplete', body: 'Grace Whitfield starts Nov 16 — I-9 documents still missing.', time: 'Yesterday', unread: true, route: { page: 'profile', employeeId: 'e16', tab: 'documents' } },
  { id: 'n4', title: 'DocuSign completed', body: 'Leo Moreau signed the Employee Handbook Acknowledgment.', time: 'Yesterday', unread: false, route: { page: 'profile', employeeId: 'e13', tab: 'documents' } },
];
